import {CompanyEmail, type CompanyEmailData} from "@/types/company/CompanyEmail";
import {BussinessLine, type BussinessLineData} from "@/types/site_admin/bussiness-lines";
import {CompanyKpi, type CompanyKpiData} from "@/types/company/CompanyKpi.ts";
import {CompanyAnnex, type CompanyAnnexData} from "@/types/company/CompanyAnnex.ts";

export class CompanyBusinessLine {
    public id: number | null;
    public company_id: number;
    public business_line_id: number;
    public api_code: string | null;
    public create_in_api: boolean;
    public enabled_for_client: boolean;
    public api_status: number;
    public api_message: string | null;
    public annex_active: boolean;
    public companyEmail: CompanyEmail;
    public clientEmail: CompanyEmail;
    public businessLine: BussinessLine | null;
    public companyKpis: CompanyKpi[];
    public companyAnnexes: CompanyAnnex[];
    public activeCompanyAnnexes: CompanyAnnex[];

    constructor(data: CompanyBusinessLineData | undefined | null = undefined) {
        if (data === undefined || data === null) {
            this.id = null;
            this.company_id = 0;
            this.business_line_id = 0;
            this.api_code = null;
            this.create_in_api = false;
            this.enabled_for_client = false;
            this.api_status = 0;
            this.api_message = null;
            this.annex_active = false;
            this.companyEmail = new CompanyEmail();
            this.companyEmail.email_type = 'UIT emails';
            this.clientEmail = new CompanyEmail();
            this.clientEmail.email_type = 'Client Notification emails';
            this.businessLine = null;
            this.companyKpis = [];
            this.companyAnnexes = [];
            this.activeCompanyAnnexes = [];

        } else {
            this.id = data.id;
            this.company_id = data.company_id;
            this.business_line_id = data.business_line_id;
            this.api_code = data.api_code;
            this.create_in_api = data.create_in_api;
            this.enabled_for_client = data.enabled_for_client;
            this.api_status = data.api_status;
            this.api_message = data.api_message;
            this.annex_active = data.annex_active;
            if (data.companyEmail !== undefined && data.companyEmail !== null) {
                this.companyEmail = new CompanyEmail(data.companyEmail);
            } else {
                this.companyEmail = new CompanyEmail();
                this.companyEmail.email_type = 'UIT emails';
            }
            if (data.clientEmail !== undefined && data.clientEmail !== null) {
                this.clientEmail = new CompanyEmail(data.clientEmail);
            } else {
                this.clientEmail = new CompanyEmail();
                this.clientEmail.email_type = 'Client Notification emails';
            }
            this.businessLine = null;
            if (data.businessLine !== undefined) {
                this.businessLine = new BussinessLine(data.businessLine);
            }
            this.companyKpis = [];
            if (data.companyKpis !== undefined) {
                data.companyKpis.forEach(companyKpi => this.companyKpis.push((new CompanyKpi(companyKpi))));
            }
            this.companyAnnexes = [];
            if (data.companyAnnexes !== undefined) {
                data.companyAnnexes.forEach(companyAnnex => this.companyAnnexes.push((new CompanyAnnex(companyAnnex))));
            }
            this.activeCompanyAnnexes = [];
            if (data.activeCompanyAnnexes !== undefined) {
                data.activeCompanyAnnexes.forEach(activeCompanyAnnex => this.activeCompanyAnnexes.push((new CompanyAnnex(activeCompanyAnnex))));
            }
        }
    }

    serializeData(without_relations: boolean | Array<string> = false): CompanyBusinessLineData {
        const serialized_data: CompanyBusinessLineData = {
            id: this.id,
            company_id: this.company_id,
            business_line_id: this.business_line_id,
            api_code: this.api_code,
            create_in_api: this.create_in_api,
            enabled_for_client: this.enabled_for_client,
            api_status: this.api_status,
            api_message: this.api_message,
            annex_active: this.annex_active,
        }

        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyEmail')
            )
        ) {
            serialized_data.companyEmail = this.companyEmail.serializeData();
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('clientEmail')
            )
        ) {
            serialized_data.clientEmail = this.clientEmail.serializeData();
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyKpis')
            )
        ) {
            serialized_data.companyKpis = [];
            this.companyKpis.forEach(el => {
                serialized_data.companyKpis.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyAnnexes')
            )
        ) {
            serialized_data.companyAnnexes = [];
            this.companyAnnexes.forEach(el => {
                serialized_data.companyAnnexes.push(el.serializeData())
            })
        }

        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('activeCompanyAnnexes')
            )
        ) {
            serialized_data.activeCompanyAnnexes = [];
            this.activeCompanyAnnexes.forEach(el => {
                serialized_data.activeCompanyAnnexes.push(el.serializeData())
            })
        }

        return serialized_data;
    }
}


export type CompanyBusinessLineData = {
    id: number | null;
    company_id: number;
    business_line_id: number;
    api_code: string | null;
    create_in_api: boolean;
    enabled_for_client: boolean;
    api_status: number;
    api_message: string | null;
    annex_active: boolean;
    companyEmail: CompanyEmailData | undefined;
    clientEmail: CompanyEmailData | undefined;
    businessLine: BussinessLineData | undefined;
    companyKpis: CompanyKpiData[] | undefined;
    companyAnnexes: CompanyAnnexData[] | undefined;
    activeCompanyAnnexes: CompanyAnnexData[] | undefined;

}
